import React from 'react'

import ProjectCarouselButtons from '../ProjectCarouselButtons'

const XenithGoods = () => {
    const display = () => {
        if (window.innerWidth > 500) {
            return true
        }
        else if (window.innerWidth < 500) {
            return false
        }
    }
    return (
        <>
            <div className="Project--split--window">
                <div className="Project-Carousel-info-container">
                    <div id="carouselExampleIndicatorsXenithGoods" className="carousel slide Project-Carousel-container">

                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <video controls="controls" className="d-block w-100 carousel-item-img">
                                    <source src="../IMG/XenithGoods/XenithGoods.mp4" type="video/mp4" />
                                </video>
                            </div>
                            <div className="carousel-item">
                                <img src="../IMG/XenithGoods/MarketPlace.png" className="d-block w-100 carousel-item-img"
                                    alt="..." />
                            </div>
                            <div className="carousel-item">
                                <img src="../IMG/XenithGoods/ProductPage.png" className="d-block w-100 carousel-item-img"
                                    alt="..." />
                            </div>
                            <div className="carousel-item">
                                <img src="../IMG/XenithGoods/Checkout.png" className="d-block w-100 carousel-item-img"
                                    alt="..." />
                            </div>
                            <div className="carousel-item">
                                <img src="../IMG/XenithGoods/OutOfStock.png" className="d-block w-100 carousel-item-img"
                                    alt="..." />
                            </div>
                            <div className="carousel-item">
                                <img src="../IMG/XenithGoods/Cart.png" className="d-block w-100 carousel-item-img"
                                    alt="..." />
                            </div>
                            <div className="carousel-item">
                                <img src="../IMG/XenithGoods/SignUp.png" className="d-block w-100 carousel-item-img"
                                    alt="..." />
                            </div>
                            <div className="carousel-item">
                                <img src="../IMG/XenithGoods/AddProduct.png" className="d-block w-100 carousel-item-img"
                                    alt="..." />
                            </div>
                            <div className="carousel-item">
                                <img src="../IMG/XenithGoods/UpdateProduct.png" className="d-block w-100 carousel-item-img"
                                    alt="..." />
                            </div>
                            <div className="carousel-item">
                                <img src="../IMG/XenithGoods/DeleteProduct.png" className="d-block w-100 carousel-item-img"
                                    alt="..." />
                            </div>
                        </div>

                        <ProjectCarouselButtons tag="XenithGoods" />

                    </div>

                    <div className="Project-info-container">
                        <div className="Project--info--Para-container">
                            <p className="Project--info--heading">XenithGoods</p>
                            <p className="Project--info--subheading">FullStack Web Development</p>
                            <p className="Project--info--subheading">Using Next.js</p>
                            {display() ? <><p className="Project--info--Para">XenithGoods redefines online shopping with simplicity, security, and seamless functionality. Advanced payment processing, efficient cart management, and intuitive administration features create a streamlined and enjoyable experience for users.</p>
                                <p className="Project--info--Para">Explore our platform and enjoy a modern e-commerce journey with XenithGoods – where convenience and excellence converge for a superior online shopping destination.</p></> : <p className="Project--info--Para">XenithGoods redefines online shopping with simplicity, security, and seamless functionality. Advanced payment processing, efficient cart management, and intuitive administration features.</p>}
                        </div>
                        <div className="Project--info--links">
                            <a href="https://xenithgoods.vercel.app" target='__blank'>XenithGoods Website Link</a>
                        </div>
                        <div className="Project--info--tech">
                            <p>Next.js</p>
                            <p>MongoDB</p>
                            <p>Express.js</p>
                            <p>Node.js</p>
                            <p>Paytm</p>
                            <p>Javascript</p>
                            <p>Tailwind Css</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default XenithGoods